import $ from 'jquery';
import { resetLabel } from '../hamburger/hamburger';

export default () => {

    //=====================> FILTRI <=====================
    var $grid = null;
    var filters = "";

    //applico filtri
    const applyFilters = () => {
        $grid.isotope({
            itemSelector: '.progetto-preview',
            layoutMode: 'fitRows',
            filter: createFilterString()
        });
    }

    // init Isotope
    const initGrid = () => {
        restoreFilter();
        $grid = $('.grid').isotope({
            itemSelector: '.progetto-preview',
            layoutMode: 'fitRows',
            filter: createFilterString()
        });
        $grid.isotope('on', 'layoutComplete', function () {
            //console.log("done!");
            var gridLoaded = new Event('grid-loaded');
            document.dispatchEvent(gridLoaded);
        });
    }

    //receve event 
    if (document.addEventListener) {
        document.addEventListener('loading-ended', initGrid, false);
    } else {
        document.attachEvent('loading-ended', initGrid);
    }

    //disattivo tutti i filtri e attivo solo filtro tutti
    $('.filter-all').on('click', function () {
        resetLabel();
        $(this).addClass('filter-selected');
        $('.project-filter').removeClass('filter-selected');
        applyFilters();
        if ($(".filters--single").length > 0) {
            $('#offcanvasWithBothOptions .close').click();
        }
    })

    //reset filtro attivo
    $('#activeFilterLabel').on("click", function () {
        resetLabel();
        $('.filter-all').addClass('filter-selected');
        $('.project-filter').removeClass('filter-selected');
        applyFilters();
    })

    //attivo filtro corrente
    $('.project-filter').on('click', function (e) {
        resetLabel();
        if ($(".filters--single").length > 0) {
            $('.filter').removeClass('filter-selected');
            $('#offcanvasWithBothOptions .close').click();
        }
        $(this).toggleClass('filter-selected');
        if ($(".filters--single").length > 0) {
            $('#offcanvasWithBothOptions .close').click();
        }
        //se il filtro "tutti" è attivo --> disattivo
        if ($('.filter-all').attr('class').indexOf('filter-selected') !== -1) {
            $('.filter-all').removeClass('filter-selected');
        }
        if ($('.filter-selected').length == 0) {
            $('.filter-all').addClass('filter-selected');
        }
        //applico filtri al click del filtro
        applyFilters();
    })

    //costruisco stringa dei filtri attivi
    const createFilterString = () => {
        var string = "";

        $('.filter').each(function (i, item) {
            if ($(item).attr('class').indexOf('filter-selected') !== -1) {
                var value = jQuery(item).attr('data-filter');
                string += value + ", ";
                if ($(".filters--single").length > 0) {
                    string = value;
                }
            }
        })
        filters = string.replace(/,\s*$/, "");
        saveFilter(filters);
        return filters;
    }
    //=============================end===============================



    //=====================> ANIMAZIONE FILTRI <=====================

    function startAnimFilters() {
        var listFilters = $('.filter-group li');
        setTimeout(function () {
            showElemFilter(listFilters, 0);
        }, 350);
    };

    function showElemFilter(list, index) {
        if (index < list.length) {
            $(list[index]).addClass('animate');
            setTimeout(function () {
                index += 1;
                showElemFilter(list, index);
            }, 200);
        }
    }

    if (document.addEventListener) {
        document.addEventListener('loading-portfolio-ended', startAnimFilters, false);
    } else {
        document.attachEvent('loading-portfolio-ended', startAnimFilters);
    }

    //=============================end===============================


    //=====================> GESTIONE FILTRI <=====================
    const saveFilter = (str) => {
        //console.log(str);
        if ($(".filters--multiple").length > 0) {
            sessionStorage.setItem("filters", str);
        }
    }
    const restoreFilter = () => {
        if (sessionStorage.getItem("filters") && $(".filters--multiple").length > 0) {
            let f = sessionStorage.getItem("filters").split(', ');
            //console.log(f);
            $('.filter').removeClass('filter-selected');
            for (let index = 0; index < f.length; index++) {
                $('.filter[data-filter="' + f[index] + '"]').addClass('filter-selected');
            }
            if (f == "") {
                $('.filter-all').addClass('filter-selected');
            }
        }
    }
    //=============================end===============================
}


// WEBPACK FOOTER //
// ../views/partials/filters/filters.js